import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import InvoicesUploadModal from "./InvoicesUploadModal";

import { useProjectState } from "../../../context/stateContext";
import invoiceActions from "../../../redux/invoices/actions";
import DatePickerComponent from "../../Common/DatePicker/DatePicker";
import "./index.css";

const { getInvoicesData } = invoiceActions;

const InvoicesActions = () => {
  const { selectedOrganization } = useProjectState();
  const dispatch = useDispatch();
  // Local state must be declared before effects that reference it
  const [modalOpen, setModalOpen] = useState(false);
  // Local date range for invoices only (do not touch global context)
  const [localStartDate, setLocalStartDate] = useState(null);
  const [localEndDate, setLocalEndDate] = useState(null);

  // Fetch invoices when the local date range changes or when the selected organization changes.
  // This ensures the DatePicker's initial local range (passed via onRangeChange) triggers the fetch,
  // and that switching organizations refreshes the list using the currently selected local range.
  useEffect(() => {
    if (localStartDate && localEndDate) {
      dispatch(
        getInvoicesData({ startDate: localStartDate, endDate: localEndDate })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, localStartDate, localEndDate]);

  return (
    <>
      <div className="invoice-datepicker-container">
        <DatePickerComponent
          defaultThisMonth={true}
          onRangeChange={(s, e) => {
            setLocalStartDate(s);
            setLocalEndDate(e);
          }}
        />
      </div>
      <div className="invoice-actions-container" style={{ marginBottom: 16 }}>
        <Button icon={<UploadOutlined />} onClick={() => setModalOpen(true)}>
          Добави фактура
        </Button>

        <InvoicesUploadModal
          visible={modalOpen}
          onClose={() => setModalOpen(false)}
          startDate={localStartDate}
          endDate={localEndDate}
        />
      </div>
    </>
  );
};

export default InvoicesActions;
